// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RightSquareTwoToneSvg from "@fishx/icons-svg/es/asn/RightSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var RightSquareTwoTone = function RightSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RightSquareTwoToneSvg
  }));
};

RightSquareTwoTone.displayName = 'RightSquareTwoTone';
export default React.forwardRef(RightSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RightSquareTwoTone.js
// module id = 4028
// module chunks = 0